import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import "./assets/css/materialdesignicons.min.css";
import "./assets/scss/themes.scss";

import reportWebVitals from "./reportWebVitals";

import Main from "./views/landing";
import VillageProfile from "./views/profile/VillageProfile";
import ImagePage from "./views/profile/ImagePage";
import { ProfileProvider } from "./context/ContextProfile";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <BrowserRouter>
    <ProfileProvider>
      <Routes>
        {/* Marketing landing */}
        <Route path="/" element={<Main />} />

        {/* Single post/image (static "/images/:uid" outranks "/:code") */}
        <Route path="/images/:uid" element={<ImagePage />} />

        {/* aldealista.com/<village> — the printed QR target */}
        <Route path="/:code" element={<VillageProfile />} />

        {/* Anything else falls back to the landing */}
        <Route path="*" element={<Main />} />
      </Routes>
    </ProfileProvider>
  </BrowserRouter>,
);

reportWebVitals();
